/** @file Throws the PNG reader's VALIDATION error: the caller's path, `format: png` params and a hint. */
import { throwError } from '@pose2d/format/throwError';

/** VALIDATION at `path` (the image the caller names) with params `{ format: 'png', ...params }` and `hint`. */
export function pngInvalid(path: string, hint: string, params: Record<string, number> = {}): never {
  return throwError('VALIDATION', { format: 'png', ...params }, { path, hint });
}
